<template>
  <div>
    <!-- Modal Component -->
    <b-modal id="modal-center" centered :title="test.name" footer-class="d-flex justify-content-center border-0">
        <ul class="summary">
          <li class="summary-item">
            Country <span class="float-right">{{testCountryName}}</span>
          </li>
          <li class="summary-item">
            Breakout <span class="float-right">{{test.breakout}}</span>
          </li>
          <li class="summary-item">
            Carrier - Volume %<span class="float-right">{{getCarrierById(test.carrierId).name}} {{test.percentage}} %</span>
          </li>
          <li class="summary-item">
            Start date <span class="float-right">{{test.start | formatDate}}</span>
          </li>
          <li class="summary-item">
            End Date <span class="float-right">{{test.end | formatDate}}</span>
          </li>
          <li class="summary-item">
            Send notification email to SNOC<span class="float-right" :class="{'text-success': test.sendNotification, 'text-danger': !test.sendNotification}">{{test.sendNotification | toYesNoString}}</span>
          </li>
        </ul>
        <div slot="modal-footer">
          <b-button size="lg" variant="primary" @click="createTest">Confirm Execute</b-button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  created () {
    this.loadCountries()
    this.loadCarriers()
  },
  computed: {
    ...mapGetters({
      'test': 'tests/newTest',
      'getCarrierById': 'tests/getCarrierById',
      'getCountryById': 'countries/getCountryById'
    }),
    testCountryName () {
      return this.getCountryById(this.test.countryId).name
    }
  },
  methods: {
    ...mapActions({
      'saveTest': 'tests/createTest',
      'loadCarriers': 'tests/loadCarriers',
      'loadCountries': 'countries/loadCountries',
      'fetchTests': 'tests/fetchTests'
    }),
    createTest () {
      var testName = this.test.name
      this.saveTest().then(() => {
        this.$root.$emit('bv::hide::modal', 'modal-center')
        this.$root.$emit('createTestSuccess', testName)
        this.fetchTests()
      }).catch((error) => {
        this.$root.$emit('bv::hide::modal', 'modal-center')
        this.$root.$emit('createTestError', error.message)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-body {
  padding-top: 0;
}
.modal-footer {
  border: 0;
}
.summary {
  list-style: none;
  padding: 0;
  margin: 0 -16px 20px;

  .summary-item {
    padding: 20px 32px;

    &:nth-child(even) {
      background-color: #FAFAFA;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TestSummaryModal.vue